import clsx from "clsx"

import useHeightCSSVariable from "@hooks/useHeightCSSVariable"

import styles from "./PopoverBody.module.scss"
import type { PopoverBodyProps } from "./PopoverBody.types"

export default function PopoverBody(props: PopoverBodyProps) {
    const { children, className, ...rest } = props

    const bodyRef = useHeightCSSVariable<HTMLDivElement>("--popover-body-height")

    return (
        <div ref={bodyRef} className={clsx(styles.base, className)} {...rest}>
            {children}
        </div>
    )
}
